module.exports = __webpack_public_path__ + "static/media/arrow-left.6863ee00.svg";